import { Fragment, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Form, Tab, Tabs, ListGroup, Row, Col } from 'react-bootstrap';
import axios from 'axios';

import useGetter from 'hooks/use-getter';
import useInput from 'hooks/use-input';
import getHeaderToken from 'functions/getHeaderToken';
import putOptionPermissionSwitch from 'functions/putOptionPermissionSwitch';
import upsertOptionPermissionStatus from 'functions/upsertOptionPermissionStatus';
import checkPermissionStatus from "functions/checkPermissionStatus";

import CustomModal from 'components/UI/Modal';
import List from 'components/UI/List';
import createData from 'functions/createOfficeListData';
import createPermissionData from 'functions/createPermissionListData';

import findOfficeNameFromOfficeNumber from 'functions/officeCollaboration/findOfficeNameFromOfficeNumber'
import postOfficeCollaboration from 'functions/officeCollaboration/postOfficeCollaboration'
import deleteOfficeCollaboration from 'functions/officeCollaboration/deleteOfficeCollaboration'
import getCorporationCollaboration from 'functions/corporationCollaboration/getCorporationCollaboration'
import postCorporationCollaboration from 'functions/corporationCollaboration/postCorporationCollaboration'
import deleteCorporationCollaboration from 'functions/corporationCollaboration/deleteCorporationCollaboration'
import updateEmployeeLimitSettings from 'functions/updateEmployeeLimitSettings';
import getContractPeriod from 'functions/getContractPeriod';
import updateContractPeriod from 'functions/updateContractPeriod';
import * as categoryConf from 'confs/category_conf.json';

import{ Logger } from 'aws-amplify';
const logger = new Logger('Office-log');


const Office = () => {

    // Endpoints
    const url = process.env.REACT_APP_OFFICES;
    const urlPlans = process.env.REACT_APP_PLANS;
    const urlPermission = process.env.REACT_APP_OFFICE_PERMISSION;
    const urlOfficeCollaboration = process.env.REACT_APP_OFFICE_COLLABOLATION;
    const urlOfficeNames = process.env.REACT_APP_OFFICE_NAMES
    const urlEmployeeLimit = process.env.REACT_APP_EMPLOYEE_LIMIT_API;
    const urlCorporationCollaboration = process.env.REACT_APP_CORPORATION_COLLABORATION;
    const urlAvailableFacilities = process.env.REACT_APP_AVAILABLE_FACILITIES;

    const params = useParams();
    const endpoint = url + `/${params.office_no}`;
    const ep_permission = urlPermission + `/${params.office_no}`;


    // Get office data
    let res = {
        admin_name: '',
        admin_email: '',
    };
    res = useGetter(endpoint, res);

    // Get plan data
    let resPlans = { plans: [] };
    resPlans = useGetter(urlPlans, resPlans);

    // Get office permission data
    let resPerm = { data: [] };
    resPerm = useGetter(ep_permission, resPerm);

    // Get office collaboration data
    let resOfficeCollaboration = {collaborated_offices: []};
    const getOfficeCollaborationParams = {src_office_number: params.office_no};
    resOfficeCollaboration = useGetter(urlOfficeCollaboration, resOfficeCollaboration, getOfficeCollaborationParams);
    // Office collaboration state
    const [collaboratedOffices, setCollaboratedOffices] = useState([]);

    // Corporation collaboration state (for category=2 and facilities)
    const [corporationCollaborations, setCorporationCollaborations] = useState([]);
    const [availableFacilities, setAvailableFacilities] = useState([]);
    const [selectedFacility, setSelectedFacility] = useState('');
    const [isReadOnly, setIsReadOnly] = useState(true);

    // Get Employee count settings
    const initialEmployeeSettings = {
      data: undefined,
    };
    const employeeLimitParams = {office_number: params.office_no};
    const resEmployeeSettings = useGetter(urlEmployeeLimit, initialEmployeeSettings, employeeLimitParams);

    // 取得したデータを state に反映したい場合
    const [limitEmployeeCount, setLimitEmployeeCount] = useState(0);
    const [countRetirementFlag, setCountRetirementFlag] = useState(false);
    const [countLeaveFlag, setCountLeaveFlag] = useState(true);

    useEffect(() => {
      if (resEmployeeSettings && resEmployeeSettings.data !== undefined) {
        setLimitEmployeeCount(resEmployeeSettings.data.count);
        setCountRetirementFlag(resEmployeeSettings.data.count_retirement_flag);
        setCountLeaveFlag(resEmployeeSettings.data.count_leave_flag);
      }
    }, [resEmployeeSettings]);

    // Get office names data
    let resOfficeNames = {office_names: {}};
    resOfficeNames = useGetter(urlOfficeNames, resOfficeNames);

    const selections = resPlans.plans.map( (obj) => <option key={obj.id}>{obj.name}</option> );
    const currentSelection = resPlans.plans.filter(obj => {return obj.id === res.plan_id});
    let currentPlan = "";
    if ( currentSelection[0] ) { currentPlan = currentSelection[0].name }

    const falseName = '連携しない';
    const trueName = '連携する';
    const mfpArray = [{ id: false, name: falseName }, { id: true, name: trueName }];
    const mfpSelections = mfpArray.map( (obj) => <option key={obj.id}>{obj.name}</option> );
    let currentMfpSelection = falseName;
    if ( res.mfp_enabled === true ) { currentMfpSelection = trueName };

    let currentPaymentInterval = null;
    if ( res.payment_interval_month === 1 ) { currentPaymentInterval = "月額" }
    else if ( res.payment_interval_month === 12 ) { currentPaymentInterval = "年額" }

    const {
        value: enteredName,
        setValue: setEnteredName,
        isValid: isValidName,
        changeHandler: nameChangeHandler
        } = useInput(value =>
            String(value.trim()) !== ''
            && String(value.trim()).length <= 128
            );
    const {
        value: enteredEmail,
        isValid: isValidEmail,
        setValue: setEnteredEmail,
        changeHandler: emailChangeHandler
        } = useInput(value =>
            /^([a-zA-Z0-9.!#$%&'*+=?^_`{|}~-]+@[a-zA-Z0-9.!#$%&'*+=?^_`{|}~-]{1,64})+$/.test(value)
            );
    const {
        value: enteredMaxUserNum,
        isValid: isValidMaxUserNum,
        setValue: setEnteredMaxUserNum,
        changeHandler: maxUserNumChangeHandler
        } = useInput(value =>
            value !== ''
            && value > 0
            && value <= 100
            && /^[0-9]+$/.test(value)
            );
    const {
        value: enteredMaxStorage,
        isValid: isValidMaxStorage,
        setValue: setEnteredMaxStorage,
        changeHandler: maxStorageChangeHandler
        } = useInput(value =>
            value !== ''
            && value > 0
            && value <= 100
            && /^[0-9]+$/.test(value)
            );
    const {
        value: enteredPlan,
        isValid: isValidPlan,
        setValue: setEnteredPlan,
        changeHandler: planChangeHandler
        } = useInput(value =>
            String(value.trim()) !== ''
            );
    const {
        value: enteredStartDate,
        isValid: isValidStartDate,
        setValue: setEnteredStartDate,
        changeHandler: startDateChangeHandler
        } = useInput(value =>
            String(value.trim()) !== '__placeholderToAvoidError'
            );
    const {
        value: enteredCustomerId,
        setValue: setEnteredCustomerId,
        isValid: isValidCustomerId,
        changeHandler: customerIdChangeHandler
        } = useInput(value =>
            /^([0-9]{10})+$/.test(value)
            );
    const {
        value: enteredMfpStatus,
        setValue: setEnteredMfpStatus,
        isValid: isValidMfpStatus,
        changeHandler: mfpStatusChangeHandler
        } = useInput(value =>
            String(value.trim()) !== ''
            );
    const {
        value: enteredPaymentIntervalMonth,
        setValue: setEnteredPaymentIntervalMonth,
        isValid: isValidPaymentIntervalMonth,
        changeHandler: paymentIntervalMonthChangeHandler
        } = useInput( value =>
            String(value.trim()) !== ''
        );
    const {
        value: enteredCollaborateOfficeNumber,
        setValue: setEnteredCollaborateOfficeNumber,
        isValid: isValidCollaborateOfficeNumber,
        changeHandler: collaborateOfficeNumberChangeHandler
        } = useInput( value =>
            (value !== params.office_no)
            && (value in resOfficeNames.office_names)
            && (!collaboratedOffices.includes(value))
        );


    let isReadyToSubmit = false;
    if ( isValidName
            && isValidEmail
            && isValidMaxUserNum
            && isValidMaxStorage
            && isValidPlan
            && isValidStartDate
            //&& isValidEndDate
            && isValidCustomerId
            && isValidMfpStatus
            && isValidPaymentIntervalMonth
    ) { isReadyToSubmit = true };

    let isFetched = false;
    if ( res.service_enabled ){ isFetched = true }else{isFetched = false};

    // States
    const [ isModal, setIsModal ] = useState(false);
    const [ isShiftExternallinkPerm, setIsShiftExternallinkPerm ] = useState(''); // 1, 0 or null
    const [ isShiftMedworkslinkPerm, setIsShiftMedworkslinkPerm ] = useState(''); // 1, 0 or null
    const [ isShiftStaffrequestPerm, setShiftStaffrequestPerm ] = useState('');
    const [ shiftExternalApiTypePerm, setShiftExternalApiTypePerm ] = useState(null); // 0: none, 1: freee

    // 無償トライアルの期限設定
    const [contractStatus, setContractStatus] = useState('demo');
    const [trialStartDate, setTrialStartDate] = useState('');
    const [isTrialConfirmed, setIsTrialConfirmed] = useState(false);
    const [trialEndDate, setTrialEndDate] = useState('');
    const [extendDays, setExtendDays] = useState(0);
    const [totalExtendedDays, setTotalExtendedDays] = useState(0);
    // 担当者の設定
    const [contractPerson, setContractPerson] = useState('');
    // 契約開始日
    const [contractStartDate, setContractStartDate] = useState('');

    useEffect(() => {
        //setIsShiftExternallinkPerm( !checkedStatusShiftExtlink ? '' : ( checkedStatusShiftExtlink === 1 ? 1 : ( checkedStatusShiftExtlink === 0 ? 0 : null )))
        setEnteredName( !res.admin_name ? '' : res.admin_name );
        setEnteredEmail( !res.admin_email ? '' : res.admin_email );
        setEnteredMaxUserNum( !res.max_user_num ? '' : res.max_user_num );
        setEnteredMaxStorage( !res.max_strage_size ? '' : res.max_strage_size );
        setEnteredPlan( !currentPlan ? '' : currentPlan );
        setEnteredStartDate( !res.start_date ? '' : res.start_date );
        //setEnteredEndDate( !res.end_date ? '' : res.end_date );
        setEnteredCustomerId( !res.customer_id ? '' : res.customer_id );
        setEnteredMfpStatus( !currentMfpSelection ? '' : currentMfpSelection );
        setEnteredPaymentIntervalMonth( !currentPaymentInterval ? '' : currentPaymentInterval );
        // eslint-disable-next-line react-hooks/exhaustive-deps
        setCollaboratedOffices( !resOfficeCollaboration.collaborated_offices ? [] : resOfficeCollaboration.collaborated_offices.concat())

        // 契約期間の取得を追加
        const fetchContractInfo = async () => {
            try {
                const data = await getContractPeriod(params.office_no);
                if (data) {
                    setContractStatus(data.contract_status);
                    setTrialStartDate(data.trial_start_date);
                    setTrialEndDate(data.trial_end_date);
                    setTotalExtendedDays(data.extended_days);
                    if (data.trial_start_date && data.trial_end_date) {
                        setIsTrialConfirmed(true);
                      }

                    setContractStartDate(data.contract_start_date)
                    setContractPerson(
                        !data.contract_person
                            ? ''
                            : data.contract_person
                    );
                }
            } catch (err) {
                console.warn('契約状態の取得に失敗しましたが、初期値のままにします:', err);
                // 値は変更しない
            }
        };
        fetchContractInfo();

    }, [
        isModal,
        isShiftExternallinkPerm,
        isShiftMedworkslinkPerm,
        isShiftStaffrequestPerm,
        setEnteredName,
        setEnteredEmail,
        setEnteredMaxUserNum,
        setEnteredMaxStorage,
        setEnteredPlan,
        setEnteredStartDate,
        //setEnteredEndDate,
        setEnteredCustomerId,
        setEnteredMfpStatus,
        setEnteredPaymentIntervalMonth,
        resOfficeCollaboration
    ]);

    const fetchPermissions4UsingEffectAndState = async () => {
        const header = await getHeaderToken();
        await axios
            .get(ep_permission, header)
            .then((res) => {
                const checkedStatusShiftExtlink = checkPermissionStatus(res.data, 'shift', 'externallink');
                const checkedStatusShiftMedlink = checkPermissionStatus(res.data, 'shift', 'medworkslink');
                const checkedStatusShiftStaffrequest = checkPermissionStatus(res.data, 'shift', 'staffrequest');
                const checkedStatusShiftExternalApiType = checkPermissionStatus(res.data, 'shift', 'externallink_freee');
                // logger.info('checkedStatusShiftExtlink is: ', checkedStatusShiftExtlink);
                setIsShiftExternallinkPerm(checkedStatusShiftExtlink);
                setIsShiftMedworkslinkPerm(checkedStatusShiftMedlink);
                setShiftStaffrequestPerm(checkedStatusShiftStaffrequest);
                setShiftExternalApiTypePerm(checkedStatusShiftExternalApiType);
            })
            .catch((e) => { logger.error(e) });
    };
    fetchPermissions4UsingEffectAndState();

    const handleShiftExternalApiTypeChange = (e) => {
        const selected = e.target.value;
        const statusToSave = selected === 'freee' ? 1 : 0;
        upsertOptionPermissionStatus(
            resPerm,
            ep_permission,
            'shift',
            'externallink_freee',
            statusToSave,
            setShiftExternalApiTypePerm,
        );
    };

    useEffect(() => {
        const hasPermissionData = Array.isArray(resPerm.data) && resPerm.data.length > 0;
        if (!hasPermissionData) { return; }

        // 汎用対応が無効のときはAPI連携種別を「なし」に固定する
        if (isShiftExternallinkPerm !== 1 && shiftExternalApiTypePerm !== 0) {
            upsertOptionPermissionStatus(
                resPerm,
                ep_permission,
                'shift',
                'externallink_freee',
                0,
                setShiftExternalApiTypePerm,
            );
        }
    }, [isShiftExternallinkPerm, shiftExternalApiTypePerm, resPerm, ep_permission]);

    // Fetch corporation collaboration data
    const corporationCategory = categoryConf.categories.find(c => c.label === '法人');
    const isCorporation = res.category === corporationCategory.label || String(res.category) === corporationCategory.category;
    useEffect(() => {
        const fetchCorporationData = async () => {
            if (!urlCorporationCollaboration) return;

            if (isCorporation) {
                // 法人: corporation_office_numberで検索
                const collaborations = await getCorporationCollaboration(
                    urlCorporationCollaboration, params.office_no, true
                );
                setCorporationCollaborations(collaborations);
                setIsReadOnly(false);

                // Get available facilities (category != 2)
                if (urlAvailableFacilities) {
                    const header = await getHeaderToken();
                    try {
                        const facilitiesRes = await axios.get(urlAvailableFacilities, header);
                        if (facilitiesRes.status === 200) {
                            setAvailableFacilities(facilitiesRes.data.facilities || []);
                        }
                    } catch (e) {
                        logger.error('Failed to fetch available facilities:', e);
                    }
                }
            } else {
                // 施設: facility_office_numberで検索（逆引き）
                const result = await getCorporationCollaboration(
                    urlCorporationCollaboration, params.office_no, false
                );
                setCorporationCollaborations(result.collaborated_facilities || []);
                setIsReadOnly(true);
            }
        };
        fetchCorporationData();
    }, [isCorporation, params.office_no, urlCorporationCollaboration, urlAvailableFacilities]);

    const postRequest = async (url, body) => {
        const header = await getHeaderToken();
        axios
            .put(endpoint, body, header)
            .then((res) => {
                switch (res.status) {
                    case 204:
                        logger.info('Put request success. Received 204 response');
                        window.location.reload(false);
                        break
                    default:
                        logger.error('Put request failed. The status is not 204. res is: ', res)
                        break
                }
            })
            .catch((e) => {
                logger.error(e);
            });
    };
    /*
    const validateEnteredDates = (start, end) => {
        let isValid = false;
        if ( start === '' && end === '' ){ isValid = true
        } else if ( start !== '' && end !== '' ){
            isValid = end > start;
            if ( isValid === false ) {
                alert('契約終了日は、開始日より後の日にちを選択してください');
            }
        } else {
            alert('契約開始日、もしくは終了日を正しく入力してください');
        }
        return isValid;
    }
    */

    // ハンドラー関数の定義
    const handleUpdateEmployeeSettings = async (newEmployeeCount, newCountRetirementFlag, newCountLeaveFlag) => {
        await updateEmployeeLimitSettings(params.office_no, newEmployeeCount, newCountRetirementFlag, newCountLeaveFlag);
    };

    // 職員上限数変更時のハンドラー関数
    const handleEmployeeLimitChange = async (event) => {
        const newLimit = Number(event.target.value);
        if (isNaN(newLimit) || newLimit < 0) {
            alert("0以上の数値を入力してください");
            return;
        }
        setLimitEmployeeCount(newLimit);
        await handleUpdateEmployeeSettings(newLimit, countRetirementFlag, countLeaveFlag);
    };

    // 退職フラグのトグルハンドラー
    const toggleCountRetirementFlag = async () => {
        const newFlag = !countRetirementFlag;
        setCountRetirementFlag(newFlag);
        await handleUpdateEmployeeSettings(limitEmployeeCount, newFlag, countLeaveFlag);
    };

    // 休職フラグのトグルハンドラー
    const toggleCountLeaveFlag = async () => {
        const newFlag = !countLeaveFlag;
        setCountLeaveFlag(newFlag);
        await handleUpdateEmployeeSettings(limitEmployeeCount, countRetirementFlag, newFlag);
    };

    const paymentIntervalHandler = (paymentIntervalString) => {

        let value = null;
        switch ( paymentIntervalString ) {
            case "月額":
                value = 1
                break
            case "年額":
                value = 12
                break
            default:
                logger.error("wrong payment interval value");
                break
        }
        return value
    }

    // 契約期間変更時のハンドラー関数
    const handleContractPeriodChange = (newStatus) => {
        const formData = {
          office_number: params.office_no,
          contractStatus: newStatus, // ← 渡された値を使う
          trialStartDate,
          trialEndDate,
          totalExtendedDays,
          contractPerson,
          contractStartDate,
        };
        updateContractPeriod(formData);
      };

    // 開始時期の決定ボタンのハンドラー関数
    const handleStartDateChange = (start, end) => {
        const formData = {
          office_number: params.office_no,
          trialStartDate: start,
          trialEndDate: end,
          contractStatus,
          totalExtendedDays,
          contractPerson,
          contractStartDate,
        };
        updateContractPeriod(formData);
      };

    // 終了時期の追加ボタンのハンドラー関数
    const handleEndEndDateChange = (end, add) => {
        const formData = {
          office_number: params.office_no,
          trialStartDate,
          trialEndDate: end,
          contractStatus,
          totalExtendedDays: add,
          contractPerson,
          contractStartDate,
        };
        updateContractPeriod(formData);
      };

    const handleContractPersonBlur = () => {
        console.log("contractPerson.trim()")
        console.log(contractPerson.trim())
        updateContractPeriod({
            office_number: params.office_no,
            contractStatus,
            trialStartDate,
            trialEndDate,
            totalExtendedDays,
            contractPerson: contractPerson.trim(),
            contractStartDate,
        });
    };

    const submitHandler = async (event) => {
        event.preventDefault();

        let start = enteredStartDate;
        //let isDatesValid = validateEnteredDates(start, end);
        /*
        if ( isDatesValid === false ){
            window.location.reload(false);
            return
        }
        */
        if ( enteredStartDate === '' ){ start = null }

        const selectedPlan = resPlans.plans.filter(obj => {return obj.name === enteredPlan})
        let selectedMfpStatus = false;
        if ( enteredMfpStatus === trueName ) { selectedMfpStatus = true }

        const paymentIntervalInt = paymentIntervalHandler( enteredPaymentIntervalMonth )

        const body = {
                admin_name: enteredName,
                admin_email: enteredEmail,
                max_user_num: Number(enteredMaxUserNum),
                max_strage_size: Number(enteredMaxStorage),
                plan_id: selectedPlan[0].id,
                start_date: start,
                //end_date: null,
                customer_id: enteredCustomerId,
                mfp_enabled: selectedMfpStatus,
                payment_interval_month: paymentIntervalInt,
        };

        const initialState = {
                admin_name: res.admin_name,
                admin_email: res.admin_email,
                max_user_num: res.max_user_num,
                max_strage_size: res.max_strage_size,
                plan_id: res.plan_id,
                start_date: res.start_date,
                //end_date: res.end_date,
                customer_id: res.customer_id,
                mfp_enabled: res.mfp_enabled,
                payment_interval_month: res.payment_interval_month,
        };

        const labels = {
                admin_name: '施設管理者名',
                admin_email: '管理者email',
                max_user_num: 'ユーザ数上限',
                max_strage_size: 'ストレージ上限',
                plan_id: '契約タイプ',
                start_date: '契約開始日',
                //end_date: '契約終了日',
                customer_id: '顧客コード',
                mfp_enabled: 'IWS連携',
                payment_interval_month: '支払いタイプ',
        }

        let diff = [];
        for await ( const [key, value] of Object.entries(initialState) ) {
            if ( body[key] !== value ) {
                diff.push({ label: labels[key], before: value, after: body[key] })
            };
        }

        if ( diff.length === 0 ) {
            alert('何も変更されていません');
            window.location.reload(false);
        } else {
            let message = '以下の内容で変更されますが、よろしいですか？\r\n\r\n';
            for await ( const obj of diff ) {
                message = message + String(obj.label) + " :   " + String(obj.before) + "  -->  " + String(obj.after) + "\r\n"
            }
            let confirm = window.confirm(message);
            if ( confirm === false ) { window.location.reload(false); }
            else {
                logger.info('body is: ', body);
                postRequest(endpoint, body);
            }
        }
    };


    const clearDatesHandler = () => {
        const message = "契約開始日と終了日を空にしますか？"
        let confirm = window.confirm(message);
        if ( confirm === true ) {
            const body = {
                start_date: null,
                end_date: null,
            };
            postRequest(endpoint, body);
        }
    };

    const planLockHandler = () => {

        if ( res.service_code !== '510' ) {
            return (
                <Fragment>
                    <Form.Label>契約タイプ</Form.Label>
                        <Form.Control disabled defaultValue={ currentPlan }/>
                </Fragment>
            )
        }

        return (
            <Fragment>
                <Form.Label>契約タイプ</Form.Label>
                {isValidPlan ? " ( OK! )" : ` ( 現在のプランは${currentPlan}です。変更する契約タイプを選択してください )`}
                <Form.Control as="select" onChange={planChangeHandler} data-testid="modal-input">
                    <option>{ currentPlan }</option>
                    { selections }
                </Form.Control>
            </Fragment>
        )

    };

    const deleteOfficeCollaborationHandler = (collaboratedOfficeNumber) => {
        let confirm_status = window.confirm("連携施設を削除しますか？\n\n施設番号：" + collaboratedOfficeNumber);
        if ( confirm_status ) {
            deleteOfficeCollaboration(urlOfficeCollaboration, params.office_no, collaboratedOfficeNumber, collaboratedOffices, setCollaboratedOffices);
        }
    }

    const onFocusFunc = (e) => {
        e.currentTarget.type = "date";
    };

    let modalBody = <p>Loading</p>
    if ( isFetched === true ) {
        modalBody = (
            <Form onSubmit={submitHandler}>
                <Form.Group>

                    <Form.Label>施設管理者名</Form.Label>
                        {isValidName ? " ( OK! )" : " ( 8文字以下で入力してください )"}
                        <Form.Control defaultValue={res.admin_name} onChange={nameChangeHandler} data-testid="modal-input"/>
                    <Form.Label>管理者email</Form.Label>
                        {isValidEmail ? " ( OK! )" : " ( 有効なEmailアドレスを入力してください )"}
                        <Form.Control type="email" defaultValue={res.admin_email} onChange={emailChangeHandler} data-testid="modal-input"/>
                    <Form.Label>ユーザ数上限</Form.Label>
                        {isValidMaxUserNum ? " ( OK! )" : " ( 100以下の有効な整数を入力してください )"}
                        <Form.Control type="number" defaultValue={res.max_user_num} onChange={maxUserNumChangeHandler} data-testid="modal-input"/>
                    <Form.Label>ストレージ上限</Form.Label>
                        {isValidMaxStorage ? " ( OK! )" : " ( 100以下の有効な整数を入力してください )"}
                        <Form.Control type="number" defaultValue={res.max_strage_size} onChange={maxStorageChangeHandler} data-testid="modal-input"/>
                    <Form.Label>サービス状況</Form.Label>
                        <Form.Control disabled defaultValue="稼働中" data-testid="modal-input"/>
                    {/*
                    <Form.Label>契約タイプ</Form.Label>
                        {isValidPlan ? " ( OK! )" : ` ( 現在のプランは${currentPlan}です。変更する契約タイプを選択してください )`}
                        <Form.Control as="select" onChange={planChangeHandler} data-testid="modal-input">
                            <option>{ currentPlan }</option>
                            { selections }
                        </Form.Control>
                    */}
                    { planLockHandler() }
                    <Form.Label>契約開始日</Form.Label>
                        {isValidStartDate ? " ( OK! )" : ` ( 変更する日にちを選択してください )`}
                        <Form.Control type="text" onFocus={ onFocusFunc } defaultValue={res.start_date} onChange={startDateChangeHandler} data-testid="modal-input"/>
                    {/*
                    <Form.Label>契約終了日</Form.Label>
                        {isValidEndDate ? " ( OK! )" : ` ( 変更する開始日より後の日にちを選択してください )`}
                        <Form.Control type="text" onFocus={ onFocusFunc } placeholder={res.end_date} onChange={endDateChangeHandler} data-testid="modal-input"/>
                    */}
                    <Form.Label>支払いタイプ</Form.Label>
                        {isValidPaymentIntervalMonth ? " ( OK! )" : ` ( 契約タイプを選択してください )`}
                        <Form.Control as="select" onChange={paymentIntervalMonthChangeHandler} data-testid="modal-input">
                            <option>{ currentPaymentInterval }</option>
                            <option>月額</option>
                            <option>年額</option>
                        </Form.Control>
                    <Form.Label>顧客コード</Form.Label>
                        {isValidCustomerId ? " ( OK! )" : " ( 10桁の整数を入力してください )"}
                        <Form.Control type="number" defaultValue={res.customer_id} onChange={customerIdChangeHandler} data-testid="modal-input"/>
                    <Form.Label>IWS連携</Form.Label>
                        {isValidMfpStatus ? " ( OK! )" : " ( 選択してください )"}
                        <Form.Control as="select" onChange={mfpStatusChangeHandler} data-testid="modal-input">
                            <option>{ currentMfpSelection }</option>
                            { mfpSelections }
                        </Form.Control>
                </Form.Group>
                <Button
                    type="submit"
                    disabled={!isReadyToSubmit}
                    data-testid='submit-button'>この情報で変更</Button>
            </Form>
        );
    }

    // Create data for List component
    let listData = {};
    let listPermissionData = [{}];
    if ( res && resPlans ){ listData = createData(res, resPlans); }
    listPermissionData = createPermissionData(resPerm);

    return (
        <Fragment>
            <Tabs
                defaultActiveKey="info">

                <Tab
                    eventKey="info"
                    title="施設情報">
                        <br/>
                        <List data={ listData.dataName }/>
                        <br/>
                        <h2>基本情報</h2>
                        <List data={ listData.dataChangeable }/>
                        <Button
                            onClick={() => setIsModal(true)}
                            data-testid='open-modal-button'
                            disabled={!isFetched}>情報を更新する</Button>
                        <br/>
                        <br/>
                        <Button
                            onClick={() => clearDatesHandler()}>契約開始日を空にする</Button>
                        <br/>
                        <br/>
                        <h2>詳細</h2>
                        <List data={ listData.dataFixed }/>

                        <CustomModal
                            show={ isModal }
                            setShow={ () => {setIsModal()} }
                            header={ "施設情報の変更" }
                            body={ modalBody }/>
                </Tab>
                <Tab
                    eventKey="permission"
                    title="権限">
                        <br/>
                        <h2>シフト</h2>
                        <List data={ listPermissionData.shift }/>
                        <ListGroup horizontal>
                            <ListGroup.Item
                                variant="primary">
                                    勤怠ソフト管理<br></br>汎用対応
                            </ListGroup.Item>
                            <ListGroup.Item>
                                <Button
                                    onClick={ () => putOptionPermissionSwitch(resPerm, 'shift', 'externallink', isShiftExternallinkPerm, setIsShiftExternallinkPerm) }
                                    disabled={isShiftMedworkslinkPerm}>
                                        { isShiftExternallinkPerm === 1 ? "有効"  : "無効" }
                                </Button>
                            </ListGroup.Item>
                        </ListGroup>
                        <ListGroup horizontal>
                            <ListGroup.Item
                                variant="primary">
                                    API連携
                            </ListGroup.Item>
                            <ListGroup.Item>
                                <Form.Check
                                    inline
                                    type="radio"
                                    id="api-link-none"
                                    name="shiftExternalApiType"
                                    value="none"
                                    label="なし"
                                    checked={!(isShiftExternallinkPerm === 1 && shiftExternalApiTypePerm === 1)}
                                    onChange={handleShiftExternalApiTypeChange}
                                    disabled={isShiftExternallinkPerm !== 1}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    id="api-link-freee"
                                    name="shiftExternalApiType"
                                    value="freee"
                                    label="freee勤怠管理"
                                    checked={isShiftExternallinkPerm === 1 && shiftExternalApiTypePerm === 1}
                                    onChange={handleShiftExternalApiTypeChange}
                                    disabled={isShiftExternallinkPerm !== 1}
                                />
                            </ListGroup.Item>
                        </ListGroup>
                        <ListGroup horizontal>
                            <ListGroup.Item
                                variant="primary">
                                    勤怠ソフト管理<br></br>Medworks対応
                            </ListGroup.Item>
                            <ListGroup.Item>
                                <Button
                                    onClick={ () => putOptionPermissionSwitch(resPerm, 'shift', 'medworkslink', isShiftMedworkslinkPerm, setIsShiftMedworkslinkPerm) }
                                    disabled={isShiftExternallinkPerm}>
                                        { isShiftMedworkslinkPerm === 1 ? "有効"  : "無効" }
                                </Button>
                            </ListGroup.Item>
                        </ListGroup>
                        <ListGroup horizontal>
                            <ListGroup.Item
                                variant="primary">
                                    希望勤務収集
                            </ListGroup.Item>
                            <ListGroup.Item>
                                <Button
                                    onClick={ () => putOptionPermissionSwitch(resPerm, 'shift', 'staffrequest', isShiftStaffrequestPerm, setShiftStaffrequestPerm) }>
                                        { isShiftStaffrequestPerm === 1 ? "有効"  : "無効" }
                                </Button>
                            </ListGroup.Item>
                        </ListGroup>

                        <section className="p-3">
                        <h2 className="mt-2">職員数</h2>
                          <Form>

                            <ListGroup
                              horizontal
                              className="mb-2">
                              <ListGroup.Item
                                className="d-flex align-items-center col-2"
                                variant="primary">
                                  職員登録数上限<br />
                                  * 0は上限なし
                              </ListGroup.Item>
                              <ListGroup.Item
                                className="d-flex align-items-center justify-content-center col-1">
                                <Form.Control
                                  type="number"
                                  value={limitEmployeeCount}
                                  onChange={handleEmployeeLimitChange}
                                  data-testid="modal-input"/>
                              </ListGroup.Item>
                            </ListGroup>

                            <ListGroup
                              horizontal
                              className="mb-2">
                              <ListGroup.Item
                                className="d-flex align-items-center col-2"
                                variant="primary">
                                  退職フラグ職員をカウント
                              </ListGroup.Item>
                              <ListGroup.Item
                                className="d-flex align-items-center justify-content-center col-1">
                                <Button
                                  onClick={toggleCountRetirementFlag}>
                                      { countRetirementFlag === true ? "する"  : "しない" }
                                </Button>
                              </ListGroup.Item>
                            </ListGroup>

                            <ListGroup
                              horizontal
                              className="mb-2">
                              <ListGroup.Item
                                className="d-flex align-items-center col-2"
                                variant="primary">
                                  休職フラグ職員をカウント
                              </ListGroup.Item>
                              <ListGroup.Item
                                className="d-flex align-items-center justify-content-center col-1">
                                <Button
                                  onClick={toggleCountLeaveFlag}>
                                      { countLeaveFlag === true ? "する"  : "しない" }
                                </Button>
                              </ListGroup.Item>
                            </ListGroup>

                          </Form>
                        </section>
                        <section className="p-3">
                            <h2 className="mt-2">契約状態</h2>
                            <Form>
                                <ListGroup horizontal className="mb-2">
                                <ListGroup.Item className="d-flex align-items-center col-2" variant="primary">
                                    現在の契約状態
                                </ListGroup.Item>
                                <ListGroup.Item className="d-flex align-items-center justify-content-around col-3">
                                    <Form.Check
                                        type="radio"
                                        id="trial"
                                        label="トライアル"
                                        name="contractStatus"
                                        value="trial"
                                        checked={contractStatus === 'trial'}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            setContractStatus(newValue);
                                            handleContractPeriodChange(newValue);
                                        }}
                                        />
                                    <Form.Check
                                    type="radio"
                                    id="contracted"
                                    label="契約済み"
                                    name="contractStatus"
                                    value="contracted"
                                    checked={contractStatus === 'contracted'}
                                    onChange={(e) => {
                                        const newValue = e.target.value;
                                        setContractStatus(newValue);
                                        handleContractPeriodChange(newValue);
                                    }}
                                    />
                                    <Form.Check
                                    type="radio"
                                    id="demo"
                                    label="デモ用"
                                    name="contractStatus"
                                    value="demo"
                                    checked={contractStatus === 'demo'}
                                    onChange={(e) => {
                                        const newValue = e.target.value;
                                        setContractStatus(newValue);
                                        handleContractPeriodChange(newValue);
                                    }}
                                    />
                                    <Form.Check
                                    type="radio"
                                    id="terminated"
                                    label="解約済み"
                                    name="contractStatus"
                                    value="terminated"
                                    checked={contractStatus === 'terminated'}
                                    onChange={(e) => {
                                        const newValue = e.target.value;
                                        setContractStatus(newValue);
                                        handleContractPeriodChange(newValue);
                                    }}
                                    />
                                </ListGroup.Item>
                                </ListGroup>

                                {contractStatus === 'trial' && (
                                    <>
                                        {/* トライアル開始日 + 「から30日 決定」 */}
                                        <ListGroup horizontal className="mb-2">
                                        <ListGroup.Item className="d-flex align-items-center col-2" variant="primary">
                                            トライアル期間
                                        </ListGroup.Item>
                                        <ListGroup.Item className="d-flex align-items-center gap-2 col-6">
                                            <Form.Control
                                            type="date"
                                            value={trialStartDate}
                                            onChange={(e) => setTrialStartDate(e.target.value)}
                                            disabled={isTrialConfirmed}  // ← 決定ボタンによりdisabled
                                            style={{ maxWidth: '200px' }}
                                            />
                                            <span>から30日</span>
                                            <Button
                                                variant="outline-primary"
                                                disabled={isTrialConfirmed}
                                                onClick={() => {
                                                    if (!trialStartDate) {
                                                    alert("トライアル開始日を選択してください");
                                                    return;
                                                    }
                                                    const start = new Date(trialStartDate);
                                                    const end = new Date(start);
                                                    end.setDate(start.getDate() + 30);
                                                    const yyyy = end.getFullYear();
                                                    const mm = String(end.getMonth() + 1).padStart(2, '0');
                                                    const dd = String(end.getDate()).padStart(2, '0');
                                                    const newTrialEndDate = `${yyyy}-${mm}-${dd}`;
                                                    setTrialEndDate(newTrialEndDate);
                                                    setIsTrialConfirmed(true); // 一度押したら無効化
                                                    handleStartDateChange(trialStartDate, newTrialEndDate)
                                                }}
                                                >
                                                決定
                                                </Button>
                                        </ListGroup.Item>
                                        </ListGroup>

                                        {/* ログイン期限（決定ボタンで更新） */}
                                        <ListGroup horizontal className="mb-2">
                                        <ListGroup.Item className="d-flex align-items-center col-2" variant="primary">
                                            ログイン期限
                                        </ListGroup.Item>
                                        <ListGroup.Item className="d-flex align-items-center justify-content-center col-2">
                                            <Form.Control
                                            type="date"
                                            value={trialEndDate}
                                            readOnly
                                            />
                                        </ListGroup.Item>
                                        </ListGroup>
                                        {/* 延長機能 */}
                                        <ListGroup horizontal className="mb-2">
                                        <ListGroup.Item className="d-flex align-items-center col-2" variant="primary">
                                            期限延長
                                        </ListGroup.Item>
                                        <ListGroup.Item className="d-flex align-items-center gap-2 col-4">
                                            <Form.Control
                                            type="number"
                                            min={0}
                                            max={30}
                                            value={extendDays}
                                            onChange={(e) => setExtendDays(Number(e.target.value))}
                                            style={{ maxWidth: '80px' }}
                                            />
                                            <span>日</span>
                                            <Button
                                            variant="outline-secondary"
                                            onClick={() => {
                                                if (!trialEndDate) {
                                                alert("先にトライアル終了日を決定してください");
                                                return;
                                                }
                                                if (extendDays < 0 || extendDays > 30) {
                                                alert("延長できる日数は0〜30日の範囲です");
                                                return;
                                                }
                                                const newTotal = totalExtendedDays + extendDays;
                                                setTotalExtendedDays(newTotal);

                                                const currentEnd = new Date(trialEndDate);
                                                currentEnd.setDate(currentEnd.getDate() + extendDays);
                                                const yyyy = currentEnd.getFullYear();
                                                const mm = String(currentEnd.getMonth() + 1).padStart(2, '0');
                                                const dd = String(currentEnd.getDate()).padStart(2, '0');
                                                const newTrialEndDate = `${yyyy}-${mm}-${dd}`;
                                                setTrialEndDate(newTrialEndDate);
                                                handleEndEndDateChange(newTrialEndDate, extendDays)
                                                setExtendDays(0); // リセット
                                            }}
                                            >
                                            追加
                                            </Button>
                                        </ListGroup.Item>
                                        </ListGroup>

                                        <ListGroup horizontal className="mb-2">
                                        <ListGroup.Item className="d-flex align-items-center col-2" variant="primary">
                                            延長合計
                                        </ListGroup.Item>
                                        <ListGroup.Item className="d-flex align-items-center col-2">
                                            <Form.Control
                                            type="number"
                                            value={totalExtendedDays}
                                            readOnly
                                            />
                                            <span className="ms-2">日</span>
                                        </ListGroup.Item>
                                        </ListGroup>

                                    </>
                                )}
                                {contractStatus === 'contracted' && (
                                    <>
                                    <ListGroup horizontal className="mb-2">
                                    <ListGroup.Item
                                        className="d-flex align-items-center col-2"
                                        variant="primary"
                                    >
                                        担当者
                                    </ListGroup.Item>

                                    <ListGroup.Item className="col-3">
                                        <Form.Control
                                            type="text"
                                            value={contractPerson}
                                            maxLength={50}
                                            placeholder="担当者名"
                                            onChange={(e) => setContractPerson(e.target.value)}
                                            onBlur={handleContractPersonBlur}
                                        />
                                    </ListGroup.Item>
                                    </ListGroup>
                                    <ListGroup horizontal className="mb-2">
                                    <ListGroup.Item
                                        className="d-flex align-items-center col-2"
                                        variant="primary"
                                    >
                                        契約開始日
                                    </ListGroup.Item>

                                    <ListGroup.Item className="col-3">
                                        <Form.Control
                                        type="date"
                                        value={contractStartDate}
                                        onChange={(e) => setContractStartDate(e.target.value)}
                                        onBlur={() => {
                                            updateContractPeriod({
                                            office_number: params.office_no,
                                            contractStatus,
                                            trialStartDate,
                                            trialEndDate,
                                            totalExtendedDays,
                                            contractPerson,
                                            contractStartDate: contractStartDate,
                                            });
                                        }}
                                        />
                                    </ListGroup.Item>
                                    </ListGroup>
                                    </>
                                )}
                            </Form>
                        </section>

                </Tab>
                <Tab
                    eventKey="office_collaboration"
                    title="施設間連携"
                    >
                        <h2 className="mt-4 mb-4">連携施設</h2>
                        {collaboratedOffices.map((collaboratedOfficeNumber) =>
                            <Form key={collaboratedOfficeNumber}>
                                <Row className="mb-2">
                                    <Col xs={2}>
                                        <Form.Control
                                            type="text"
                                            defaultValue={ collaboratedOfficeNumber }
                                            disabled
                                            readOnly
                                        />
                                    </Col>
                                    <Col xs={3}>
                                        施設名：{findOfficeNameFromOfficeNumber(collaboratedOfficeNumber, resOfficeNames.office_names)}
                                    </Col>
                                    <Col xs={1}>
                                        <Button
                                            variant="danger"
                                            onClick={() => deleteOfficeCollaborationHandler(collaboratedOfficeNumber)}>削除
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        )}
                        <Form>
                            <Row>
                                <Col xs={2}>
                                    <Form.Control
                                        value={enteredCollaborateOfficeNumber}
                                        onChange={collaborateOfficeNumberChangeHandler}
                                        placeholder="0123456789-510"
                                    />
                                </Col>
                                <Col xs={3}>
                                    施設名：{findOfficeNameFromOfficeNumber(enteredCollaborateOfficeNumber, resOfficeNames.office_names, params.office_no, collaboratedOffices)}
                                </Col>
                                <Col xs={1}>
                                    <Button
                                        disabled={!isValidCollaborateOfficeNumber}
                                        onClick={() =>
                                            postOfficeCollaboration(
                                                urlOfficeCollaboration, params.office_no, enteredCollaborateOfficeNumber,
                                                setEnteredCollaborateOfficeNumber, collaboratedOffices, setCollaboratedOffices
                                            )}>追加
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                </Tab>

                <Tab
                    eventKey="corporation_collaboration"
                    title="法人管理"
                    >
                        <h2 className="mt-4 mb-4">連携施設</h2>
                        {corporationCollaborations.length === 0 ? (
                            <p className="text-muted">連携施設が登録されていません</p>
                        ) : (
                            corporationCollaborations.map((collaboration) =>
                                <Form key={collaboration.facility_office_number}>
                                    <Row className="mb-2">
                                        <Col xs={2}>
                                            <Form.Control
                                                type="text"
                                                defaultValue={collaboration.facility_office_number}
                                                disabled
                                                readOnly
                                            />
                                        </Col>
                                        <Col xs={3}>
                                            施設名：{findOfficeNameFromOfficeNumber(collaboration.facility_office_number, resOfficeNames.office_names)}
                                        </Col>
                                        {!isReadOnly && (
                                            <Col xs={1}>
                                                <Button
                                                    variant="danger"
                                                    onClick={() => {
                                                        let confirm_status = window.confirm("連携施設を削除しますか？\n\n施設番号：" + collaboration.facility_office_number);
                                                        if (confirm_status) {
                                                            deleteCorporationCollaboration(
                                                                urlCorporationCollaboration,
                                                                params.office_no,
                                                                collaboration.facility_office_number,
                                                                corporationCollaborations,
                                                                setCorporationCollaborations
                                                            );
                                                        }
                                                    }}>削除
                                                </Button>
                                            </Col>
                                        )}
                                    </Row>
                                </Form>
                            )
                        )}
                        {!isReadOnly && (
                            <Form>
                                <Row>
                                    <Col xs={2}>
                                        <Form.Control
                                            value={selectedFacility}
                                            onChange={(e) => setSelectedFacility(e.target.value)}
                                            placeholder="0123456789-510"
                                        />
                                    </Col>
                                    <Col xs={3}>
                                        施設名：{findOfficeNameFromOfficeNumber(selectedFacility, resOfficeNames.office_names)}
                                    </Col>
                                    <Col xs={1}>
                                        <Button
                                            disabled={!selectedFacility || !availableFacilities.some(f => f.office_number === selectedFacility) || corporationCollaborations.some(c => c.facility_office_number === selectedFacility)}
                                            onClick={() =>
                                                postCorporationCollaboration(
                                                    urlCorporationCollaboration,
                                                    params.office_no,
                                                    selectedFacility,
                                                    setSelectedFacility,
                                                    corporationCollaborations,
                                                    setCorporationCollaborations
                                                )
                                            }>追加
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        )}
                </Tab>

            </Tabs>
        </Fragment>
    )
};

export default Office;
